<template>
  <input
    type="date"
    :value="modelValue"
    class="date-picker"
    @input="$emit('update:modelValue', $event.target.value)"
  >
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DatePicker',

  props: {
    modelValue: {
      type: String,
      default: ''
    }
  }
})
</script>

<style scoped>
  .date-picker {
    width: 300px;
    max-width: 85vw;
    height: 40px;
    font-size: 1.5rem;
  }
</style>
